import { useContext, useEffect } from "react";
import { WeeklyContext } from "../Context/WeeklyContext";
import { developAxios } from "../axios.config";
const GetAllQuestions = () => {
	const { allQuestions, setAllQuestions } = useContext(WeeklyContext);
	useEffect(() => {
		developAxios(localStorage.getItem("token"))
			.get(`/GetAllQuestionAdmin`)
			.then(({ data }) => {
				console.log(data.questions);
				setAllQuestions(data.questions);
			})
			.catch((e) => {
				console.log(e);
			});
	}, []);
	return (
		<>
			<div>
				{allQuestions.map((e) => {
					return (
						<>
							<div class="table w-full ...">
								<div class="table-row-group">
									<div class="table-row">
										<div class="table-cell ...">Name</div>
										<div class="table-cell ...">
											{e.name}
										</div>

										<div class="table-cell ...">
											{e.languages}
										</div>
									</div>
								</div>
							</div>
						</>
					);
				})}
			</div>
		</>
	);
};

export default GetAllQuestions;
